<template>
  <AppModal
    id="verify-phone"
    close-on-backdrop
  >
    <template #title>
      <h3 class="text-center mb-5">{{$t($getConst.pages.personalDetails.verify_your_phone)}}</h3>
    </template>
    <template #content>
      <b-row class="mb-3">
        <b-col>
          <b-form-group id="phone" :label="$t($getConst.pages.personalDetails.phone_number) + '*'" label-for="phone-input">
            <VuePhoneNumberInput
              id="phone-input"
              v-model="$v.phoneBasicNumber.$model"
              :value="phone"
              class="text-capitalize"
              :class="{ 'is-invalid': $v.form.phone.$error }"
              :placeholder="$t($getConst.pages.personalDetails.phone_number)"
              :border-radius="8"
              :translations="translation"
              :clearable="true"
              no-use-browser-locale
              size="lg"
              error-color	= "#e55353"
              valid-color	= "#0051f6"
              color	= "#0051f6"
              required
              ref="PhoneNumberInput"
              @update="showPayload"
            />
            <AppFormFeedback :errors="$v.form.phone"/>
            <b-form-invalid-feedback v-if="!$v.form.phone.validPhoneNumber && $v.form.phone.required">
              {{$t($getConst.pages.form.phone_field_error)}}.
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>

        <b-col>
          <p>{{$t($getConst.pages.personalDetails.verification_code_description) | capitalize}}</p>
          <div class="input-wrapper text-center">
            <PincodeInput
              v-model="code"
              :disabled="isLoading"
              :length="6"
              placeholder="#"
            />
          </div>
          <b-form-invalid-feedback class="d-block text-center" v-if="error">{{error}}</b-form-invalid-feedback>
        </b-col>
      </b-row>

      <AppConfirmButtons
        no-cancel
        submit-text="verify"
        :is-disabled="code.length !== 6 || $v.$invalid"
        :is-loading="isLoading"
        @onSubmit="updatePhone"
      />
    </template>
  </AppModal>
</template>

<script>
  import AppModal from "../../../components/common/modals/AppModal";
  import PincodeInput from 'vue-pincode-input';
  import AppConfirmButtons from "../../../components/common/utils/AppConfirmButtons";
  import {updatePhone} from "../../../api/userPhone.api";
  import AppFormFeedback from "../../../components/common/form/AppFormFeedback";
  import VuePhoneNumberInput from 'vue-phone-number-input';
  import {required} from "vuelidate/lib/validators";

  export default {
    name: "VerificationModal",
    components: {AppFormFeedback, AppConfirmButtons, AppModal, PincodeInput, VuePhoneNumberInput},
    props: {
      phone: null
    },
    data() {
      return {
        code: "",
        isLoading: false,
        error: null,

        phoneBasicNumber:null,
        form: {
          phone: null
        },
        validNumber: true,
        translation: {
          countrySelectorLabel: '',
          countrySelectorError: '',
          phoneNumberLabel: this.$t(this.$getConst.pages.personalDetails.phone_number),
          example: ''
        },
        defaultCountry: JSON.parse(localStorage.getItem("userAccount")).scopeDefault.country_code,
      }
    },
    validations: {
      phoneBasicNumber: {validPhoneNumber() {return this.validNumber}},
      form: {
        phone: {required, validPhoneNumber() {return this.validNumber}},
      },
    },
    methods: {
      showPayload (payload) {
        this.$v.form.phone.$model = payload.formattedNumber;
        this.validNumber = !!payload.isValid;
      },
      updatePhone() {
        this.isLoading = true;
        this.error = null;
        updatePhone(this.form.phone, this.code).then(
          (response) => {
            this.$emit("close", response.data);
            this.$store.dispatch("auth/setUserPhone", response.data.phone);
            this.$store.dispatch("auth/setUserSms", response.data.sendSms);
            this.isLoading = false;
            this.$snotify.success(this.$t(this.$getConst.pages.alerts.success_update));
          },
          (error) => {
            if (error.response.status === 404) {
              this.$snotify.error(this.$t(this.$getConst.pages.alerts.no_verification_code_for_this_phone));
              this.$emit("close");
            } else if(error.response.status === 403 || error.response.status === 422) {
              this.error = this.$t(this.$getConst.pages.personalDetails.invalid_verification_code);
            }  else {
              this.handleApiError(error);
              this.$emit("close");
            }
            this.isLoading = false;
          }
        )
      }
    },
    mounted() {
      this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
        if (modalId === "verify-phone") {
          this.code = "";
          this.form.phone = this.phone;
          this.phoneBasicNumber = this.phone;
        }
      })
    },
    watch: {
      phone() {
        this.form.phone = this.phone;
        this.phoneBasicNumber = this.phone;
      }
    }
  }
</script>

<style scoped>

</style>
